import { IOrderDetail, IOrderType } from '../../../models';
import { formatMoney, sanitizeCsvString } from '../../../helpers';

export const formatCSVColumns = (
  orders: IOrderDetail[],
  csv: string,
  orderTypes: IOrderType[],
  isActive?: boolean
) => {
  orders.forEach(row => {
    // Date/Time
    if (row.dateOrdered) {
      const dateTime = new Date(row.dateOrdered);
      const date = dateTime.toLocaleDateString('en-US');
      const time = dateTime.toLocaleTimeString('en-US');
      csv += `${date} ${time},`;
    } else {
      csv += ',';
    }

    // Order No.
    if (!isActive) {
      if (row.sageOrderNumbers) {
        csv += `${row.sageOrderNumbers.map(sageNo => sageNo).join('; ')},`;
      } else {
        csv += ',';
      }
    }

    // Blinq No.
    if (row.fieldOrderId) {
      csv += `${row.fieldOrderId},`;
    } else {
      csv += ',';
    }

    // Order Type
    const type = orderTypes && orderTypes.find(orderType => row.type === orderType.sageId);
    const typeName = type ? type.typeName : '';
    if (row.type && typeName) {
      const cleanTypeName = sanitizeCsvString(typeName);
      csv += `${cleanTypeName},`;
    } else {
      csv += ',';
    }

    // Order Desc.
    if (row.description) {
      const cleanedDescription = sanitizeCsvString(row.description.name);
      csv += `${cleanedDescription},`;
    } else {
      csv += ',';
    }

    // Neighborhood
    if (row.job) {
      const cleanJob = sanitizeCsvString(row.job);
      csv += `${cleanJob},`;
    } else {
      csv += '';
    }

    // Owner
    if (row.orderPlacer) {
      const cleanOrderPlacer = sanitizeCsvString(row.orderPlacer);
      csv += `${cleanOrderPlacer},`;
    } else {
      csv += ',';
    }

    // Parts
    if (row.parts) {
      csv += `"${row.parts
        .map(part => (part.partName ? part.partName.replace('#', '') : null))
        .join(' ')}",`;
    } else {
      csv += ',';
    }

    // Total
    if (row.totalCost) {
      csv += `"${formatMoney(row.totalCost)}",`;
    } else {
      csv += ',';
    }

    // Status
    if (row.currentStatus) {
      const cleanStatus = sanitizeCsvString(row.currentStatus.status);
      csv += `${cleanStatus}`;
    } else {
      csv += '';
    }
    csv += '\n';
  });
  return csv;
};
